import { FilterStocksType, MarketMoverBatch, MoverType } from '@stockbitgroup/protos/financial/order_trade/entity/v1/market_mover_pb';
import { MoverFilterType, MoverListResponse, MoverTypeStr } from '../../../@types/movers';

export const MapMoverStr: Record<MoverType, MoverTypeStr> = {
  [MoverType.UNSPECIFIED]: 'MOVER_TYPE_UNSPECIFIED',
  [MoverType.TOP_VALUE]: 'MOVER_TYPE_TOP_VALUE',
  [MoverType.TOP_VOLUME]: 'MOVER_TYPE_TOP_VOLUME',
  [MoverType.TOP_FREQUENCY]: 'MOVER_TYPE_TOP_FREQUENCY',
  [MoverType.TOP_GAINER]: 'MOVER_TYPE_TOP_GAINER',
  [MoverType.TOP_LOSER]: 'MOVER_TYPE_TOP_LOSER',
  [MoverType.NET_FOREIGN_BUY]: 'MOVER_TYPE_NET_FOREIGN_BUY',
  [MoverType.NET_FOREIGN_SELL]: 'MOVER_TYPE_NET_FOREIGN_SELL',
};

export const MapMoverEnum: Record<MoverTypeStr, MoverType> = {
  MOVER_TYPE_UNSPECIFIED: MoverType.UNSPECIFIED,
  MOVER_TYPE_TOP_VALUE: MoverType.TOP_VALUE,
  MOVER_TYPE_TOP_VOLUME: MoverType.TOP_VOLUME,
  MOVER_TYPE_TOP_FREQUENCY: MoverType.TOP_FREQUENCY,
  MOVER_TYPE_TOP_GAINER: MoverType.TOP_GAINER,
  MOVER_TYPE_TOP_LOSER: MoverType.TOP_LOSER,
  MOVER_TYPE_NET_FOREIGN_BUY: MoverType.NET_FOREIGN_BUY,
  MOVER_TYPE_NET_FOREIGN_SELL: MoverType.NET_FOREIGN_SELL,
};

export const MapMoverFilterEnum: Record<MoverFilterType, FilterStocksType> = {
  FILTER_STOCKS_TYPE_UNSPECIFIED: FilterStocksType.UNSPECIFIED,
  FILTER_STOCKS_TYPE_MAIN_BOARD: FilterStocksType.MAIN_BOARD,
  FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD: FilterStocksType.DEVELOPMENT_BOARD,
  FILTER_STOCKS_TYPE_ACCELERATION_BOARD: FilterStocksType.ACCELERATION_BOARD,
  FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD: FilterStocksType.NEW_ECONOMY_BOARD,
  FILTER_STOCKS_TYPE_SPECIAL_MONITORING_BOARD: FilterStocksType.SPECIAL_MONITORING_BOARD,
  FILTER_STOCKS_TYPE_WARRANT_AND_RIGHT: FilterStocksType.WARRANT_AND_RIGHT,
  FILTER_STOCKS_TYPE_SHARIA: FilterStocksType.SHARIA,
};

export const convertMoversFilterListToEnum =
  (arr: MoverFilterType[]) => arr.map((str) => MapMoverFilterEnum[str]);

export const convertMoverWStoAPI = (data?: MarketMoverBatch) => {
  if (!data) return undefined;

  const result: MoverListResponse = {
    mover_type: MapMoverStr[data.moverType],
    mover_list: data.batch.map((old) => ({
      stock_detail: {
        code: old.stockDetail?.code || '',
        name: old.stockDetail?.name || '',
        icon_url: old.stockDetail?.iconUrl || '',
        has_uma: old.stockDetail?.hasUma || false,
        notations: old.stockDetail?.notations || [],
        corpaction: {
          active: old.stockDetail?.corpaction?.active || false,
          icon_url: old.stockDetail?.corpaction?.iconUrl || '',
          text: old.stockDetail?.corpaction?.text || '',
        },
      },
      price: old.price,
      change: {
        percentage: old.change?.percentage || 0,
        value: old.change?.value || 0,
      },
      frequency: {
        raw: old.frequency?.raw || 0,
        formatted: old.frequency?.formatted || '',
      },
      value: {
        raw: old.value?.raw || 0,
        formatted: old.value?.formatted || '',
      },
      volume: {
        raw: old.volume?.raw || 0,
        formatted: old.volume?.formatted || '',
      },
      net_foreign_buy: {
        raw: old.netForeignBuy?.raw || 0,
        formatted: old.netForeignSell?.formatted || '',
      },
      net_foreign_sell: {
        raw: old.netForeignSell?.raw || 0,
        formatted: old.netForeignSell?.formatted || '',
      },
      net_buy: {
        raw: old.netBuy?.raw || 0,
        formatted: old.netBuy?.formatted || '',
      },
      net_sell: {
        raw: old.netSell?.raw || 0,
        formatted: old.netSell?.formatted || '',
      },
    })),
  };
  return result;
};
